// extracted by mini-css-extract-plugin
module.exports = {"tab-content":"InclusionsModal_tab-content__l02zn","tabContent":"InclusionsModal_tab-content__l02zn","contents":"InclusionsModal_contents__3zoMF"};